export * from './Component';
export type { CommonCheckboxProps } from './typing';
